<template>
  <div id="covid" class="fancybox-container-16 container">
    <div class="row bg-white py-3 px-1">
      <div class="col-md-7">
        <slot name="image">
          <p class="text-center">PUT YOUR IMAGE HERE</p>
        </slot>
      </div>
      <div class="col-md-9">
        <slot name="text">
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Error neque vel, quo, commodi delectus dolorem reprehenderit accusamus vero laboriosam cupiditate reiciendis maxime, minima assumenda accusantium cum veniam eaque et impedit.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem commodi quas aut, non nulla aspernatur ipsum voluptatum dolorem itaque, eligendi eius fuga repellat esse. Nesciunt numquam totam voluptatibus praesentium ullam.</p>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import VueCookies from 'vue-cookies'
  Vue.use(VueCookies)

  import '@fancyapps/fancybox'

  export default {
    props: {},
    data() {
      return {
        showPopup: false
      }
    },
    methods: {
      getCookie() {
        return (this.$cookies.get('showModalCovid') == 'true' || this.$cookies.get('showModalCovid') == null);
      },
      setCookie(value) {
        this.$cookies.set('showModalCovid', value, '1d')
        this.showPopup = value
      },
    },
    mounted() {
      const component = this

      // this.showPopup = this.getCookie()

      if (this.showPopup) {
        $.fancybox.open({
          src: '#covid',
          type: 'inline',
          opts: {
            animationEffect: "zoom-in-out",
            animationDuration: 500,
            btnTpl: {
              // smallBtn: `
              //       <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
              //           <i class="icon-close"></i>
              //       </button>
              //       `,
            },
            afterClose: function () {
              component.setCookie(false)
            }
          },
        });
      }
    },
  }
</script>

<style lang="scss">
</style>